module.exports = __webpack_public_path__ + "static/img/coin.0a3cd911.png";